module.exports = __webpack_public_path__ + "img/mergdata_hifi_2.32eb31a1.png";